/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBarberShiftStartMutationRequest, PostApiBarberShiftStartMutationResponse, PostApiBarberShiftStart400, PostApiBarberShiftStart401, PostApiBarberShiftStart403, PostApiBarberShiftStart404, PostApiBarberShiftStart500 } from "../entities/PostApiBarberShiftStart";

function getPostApiBarberShiftStartUrl() {
  const res = { method: 'POST', url: `/api/barber/shift/start` as const }
  return res
}

/**
 * @description Мастер начинает рабочую смену
 * @summary Начать смену
 * {@link /api/barber/shift/start}
 */
export async function postApiBarberShiftStart(data: PostApiBarberShiftStartMutationRequest, config: Partial<RequestConfig<PostApiBarberShiftStartMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PostApiBarberShiftStartMutationResponse, ResponseErrorConfig<PostApiBarberShiftStart400 | PostApiBarberShiftStart401 | PostApiBarberShiftStart403 | PostApiBarberShiftStart404 | PostApiBarberShiftStart500>, PostApiBarberShiftStartMutationRequest>({ method : "POST", url : getPostApiBarberShiftStartUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}